import * as React from "react";
import classnames from "classnames";
/* empty css                         */
const StoreListTopContent = ({ title, description, className, ...rest }) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("store-list-top-content-stores-v2", className) }, title && /* @__PURE__ */ React.createElement("h1", { className: "h3" }, title), description && /* @__PURE__ */ React.createElement("p", { "data-t": "store-list-top-content-description" }, description));
export {
  StoreListTopContent as default
};
//# sourceMappingURL=StoreListTopContent.js.map
